










































import { Component, Prop, Vue } from "vue-property-decorator";
import { FolderEntry, Breadcrumb } from "@/models/file";
import {
  getPhotoEntries,
  savePhotoEntry,
  deletePhotoEntry,
  readPhotoEntry
} from "@/api/photo-api";
import download from "@/helpers/download";
import uploadPhotoProject from "@/helpers/uploadPhotoProject";

import FileExplorer from "@/templates/FileExplorer.vue";
import VPreview, { PreviewAction } from "../components/VPreview.vue";
import NewFolderRequest from "../models/new-folder-request";
import NewFolderModal from "../components/NewFolderModal.vue";

@Component({
  components: {
    VPreview,
    FileExplorer,
    NewFolderModal
  }
})
export default class ProjectPhotoPage extends Vue {
  @Prop({ required: true }) projectId!: string;

  currentFolderId: any = "0";
  entries: FolderEntry[] = [];
  path: Breadcrumb[] = [];
  selectedPhoto: FolderEntry | null = null;
  allowExtensions: string = "jpeg|jpg|png|JPEG|JPG|PNG"; // |gif|svg|bmp

  newFolderRequest = new NewFolderRequest();

  showNewFolderModal() {
    this.newFolderRequest = new NewFolderRequest();
    this.newFolderRequest.name = "新しいフォルダ";
    this.newFolderRequest.projectId = this.projectId;
    this.newFolderRequest.parentFolderId = this.currentFolderId;
  }

  get previewActions(): PreviewAction[] {
    if (!this.selectedPhoto) return [];
    const actions = [];
    if (this.canWritePhoto() && this.canAddFolder()) {
      actions.push(this.createDeleteAction());
    }
    actions.push(this.createDownloadAction());
    return actions;
  }

  get user() {
    return this.$store.getters.user;
  }

  private createDeleteAction(): PreviewAction {
    return {
      key: "delete",
      icon: "trash",
      title: "削除",
      variant: "secondary",
      click: () => {
        const confirmed = confirm("本当に削除してもよろしいですか？");
        if (!confirmed) return;
        this.removeSelectedPhoto();
        (this.$refs.preview as any).hide();
      }
    };
  }

  private createDownloadAction(): PreviewAction {
    return {
      key: "download",
      icon: "download",
      title: "ダウンロード",
      variant: "secondary",
      click: () => {
        this.download();
      }
    };
  }

  get permissions(): string[] {
    return this.$store.getters.permissions;
  }

  canWritePhoto() {
    return (
      this.permissions.includes("service/project_operation") ||
      this.permissions.includes("project/photo_operation")
    );
  }

  canAddFolder() {
    return (
      this.permissions.includes("service/project_operation") ||
      this.permissions.includes("project/document_secret")
    );
  }

  download() {
    if (!this.selectedPhoto) return;
    download(this.selectedPhoto.image, this.selectedPhoto.name);
  }

  created() {
    this.initEntries();
  }

  open(entry: FolderEntry) {
    switch (entry.kind) {
      case "folder":
        this.changeCurrentFolder(entry);
        break;
      case "file":
        this.selectedPhoto = entry;
        readPhotoEntry(entry.entryId);
        (this.$refs.preview as VPreview).show();
        this.initEntries();
        break;
    }
  }

  changeCurrentFolder(entry: { entryId?: any }) {
    this.currentFolderId = entry.entryId || 0;
    this.initEntries();
  }

  uploadPhotoFiles(files: FileList) {
    // console.log("Upload Files: ", files);
    if (!files.length) return;
    Array.from(files).forEach(uploadFile => {
      this.uploadPhoto(uploadFile);
    });
  }
  async uploadPhoto(uploadFile: File) {
    // console.log("Upload File: ", uploadFile);
    await uploadPhotoProject(this.projectId, this.currentFolderId, uploadFile);
    this.initEntries();
  }

  async addFolder() {
    await savePhotoEntry(this.newFolderRequest.toFormData());
    await this.initEntries();
  }

  async removeSelectedPhoto() {
    if (!this.selectedPhoto) return;
    this.remove(this.selectedPhoto);
    this.selectedPhoto = null;
  }

  async initEntries() {
    const { entries, path } = await getPhotoEntries(
      this.projectId,
      this.currentFolderId
    );
    this.entries = entries;
    this.path = path;
  }

  async mv(id: any, folderId: any) {
    const entry = this.entries.find(e => String(e.entryId) === id);
    if (!entry) return;
    if (entry.entryId === folderId) return;
    const data = new FormData();
    data.append("id", String(entry.entryId));
    data.append("name", entry.name);
    data.append("kind", entry.kind);
    data.append("projectId", this.projectId);
    data.append("parentFolderId", folderId);
    await savePhotoEntry(data);
    this.initEntries();
  }

  async rename(entry: FolderEntry, name: string) {
    const data = new FormData();
    data.append("id", String(entry.entryId));
    data.append("name", name);
    data.append("kind", entry.kind);
    data.append("projectId", this.projectId);
    data.append("parentFolderId", this.currentFolderId);
    await savePhotoEntry(data);
    this.initEntries();
  }

  async remove(entry: FolderEntry) {
    await deletePhotoEntry(entry.entryId);
    await this.initEntries();
  }
}
